export const environment = {
  production: false,

  apiUrl: 'https://coteo-api.duckdns.org/',
  loadStripe: 'pk_live_51Riv4nAWXw0TwgrdANu6s3kwBHrr08JGlfTlPU1TzvDMSJBx5YAlYan363wvmXMHJoxEVc27Q0FQLp23VO6Vk0dE00RUzE4hAI'
};
